module.exports = __webpack_public_path__ + "img/anime3.3b91359d.png";